import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

import { getFormattedDate, slugify } from '../utils/helpers'
import colin from '../../static/colin_head.png'

export const PostSidebar = ({
  tags = [],
  date,
  categories = [],
  thumbnail,
}) => {
  const cates = categories?.filter(function (category) {return category !== 'Highlight'})
  const formattedDate = getFormattedDate(date)

  return (
    <aside className="post-sidebar">
      {thumbnail && (
        <div className="post-image">
          <Img fluid={thumbnail.childImageSharp?.fluid} />
        </div>
      )}
      <div className="post-sidebar-card">
        <h2>About me</h2>
        <img src={colin} alt="Colin" className="sidebar-avatar" />
        <p>
          I'm {' '}
          <Link to="/ColinBirkenbihl">Colin Birkenbihl</Link>, and here you find my 
          latest blog posts.
        </p>
        <p>
          I'm a researcher applying methods from the field of artificial intelligence 
          and machine learning to study diseases and solve biomedical challenges.
          I have a strong interest in health AI, synthetic data, 
          and time-series analysis.

        </p>
      </div>

      <div className="post-sidebar-card">
        <h2>Post Details</h2>
        <ul>
          <li>Published {formattedDate}</li>
        </ul>

        {cates && (
          <div>
            <h2>Categories</h2>
            <ul>
              {cates.map((cat) => {
                return (
                  <li>
                  <Link
                    key={cat}
                    to={`/categories/${slugify(cat)}`}
                  >
                    {cat}
                  </Link>
                  </li>
                )
               })}
            </ul>
          </div>
        )}

        <h2>Tags</h2>
        <div className="tags">
          {tags.map((tag) => {
            return (
              <Link
                key={tag}
                to={`/tags/${slugify(tag)}`}
                className="tag"
                activeClassName="active"
              >
                {tag}
              </Link>
            )
          })}
        </div>
      </div>

      <div className="post-sidebar-card">
        <h2>Newsletter</h2>
        <p>
         Get notified when a new paper was published!
        </p>
        <p>
          <a
            href="https://birkenbihl.substack.com"
            target="_blank"
            rel="noopener noreferrer"
            className="button highlighted"
          >
            Subscribe to the Newsletter
          </a>
        </p>
      </div>
    </aside>
  )
}
